import type { SelectHTMLAttributes } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  hint?: string;
  error?: string;
}

export function Select({ label, hint, error, id, style, children, ...rest }: SelectProps) {
  const selectId = id ?? `select-${label}`;
  return (
    <div style={{ marginBottom: '16px' }}>
      <label
        htmlFor={selectId}
        style={{
          display: 'block',
          fontSize: '11px',
          color: '#d1d5db',
          marginBottom: '6px',
        }}
      >
        {label}
      </label>
      <select
        id={selectId}
        {...rest}
        style={{
          width: '100%',
          background: 'var(--color-input)',
          border: error ? '0.5px solid rgba(239, 68, 68, 0.6)' : 'var(--border-strong)',
          borderRadius: 'var(--radius-md)',
          padding: '9px 11px',
          color: 'var(--color-text-primary)',
          fontSize: '12px',
          outline: 'none',
          appearance: 'auto',
          ...style,
        }}
      >
        {children}
      </select>
      {(error ?? hint) && (
        <p
          style={{
            margin: '4px 0 0',
            fontSize: '10px',
            color: error ? 'var(--color-error-text)' : 'var(--color-text-tertiary)',
          }}
        >
          {error ?? hint}
        </p>
      )}
    </div>
  );
}
